import { useState } from "react";
import { getSupportDisplayPicUrl } from "../../../utilities/conversions";
import { BroadcastModal } from "../agents/broadcastmodal";

export default function HeaderModule({ tab, setTab, currentUser, onLogout, profile, baseUrl, setSelectedAgent }: { tab: string, setTab: (tab: string) => void, currentUser: any, onLogout: () => void, profile: any, baseUrl: string, setSelectedAgent: (agent: any) => void }) {
    const [showProfileMenu, setShowProfileMenu] = useState(false);
    const [showBroadcastModal, setShowBroadcastModal] = useState(false);
    const handleNavigation = (to: string, agent: any) => {
        setTab(to);
        setSelectedAgent(agent);
    }
    return (
        <>
            <header className="h-16 z-50 px-8 border-b border-slate-200 md:flex hidden md:flex-row items-center justify-between bg-white/80 backdrop-blur">
                <div>
                    <h1 className="text-xl font-semibold">Dashboard</h1>
                    <p className="text-xs text-slate-500">Full kontroll på agenter, kunder, kurs og omsetning.</p>
                </div>
                <div className="flex items-center gap-3">
                    <button onClick={() => handleNavigation("Agent detail", null)} className="px-4 py-2 rounded-full text-sm bg-slate-900 text-white hover:bg-black">+ Ny agent</button>
                    <button onClick={() => setShowBroadcastModal(true)} className="px-4 py-2 rounded-full text-sm bg-indigo-50 text-indigo-700 border border-indigo-100 hover:bg-indigo-100">
                        + Nytt kurs / event
                    </button>
                    <div className="relative">
                        <button
                            onClick={() => setShowProfileMenu(!showProfileMenu)}
                            className="w-9 h-9 rounded-full bg-slate-200 overflow-hidden"
                        >
                            <img
                                src={getSupportDisplayPicUrl(profile?.profile_pic, baseUrl)}
                                alt={currentUser.name}
                                className="w-full h-full object-cover"
                            />
                        </button>

                        {showProfileMenu && (
                            <div className="absolute right-0 mt-2 w-40 bg-white shadow-lg rounded-xl border border-slate-100 py-2 z-50">
                                <button className="block w-full text-left px-4 py-2 text-sm hover:bg-slate-50">
                                    Profil
                                </button>
                                <button onClick={onLogout} className="block w-full text-left px-4 py-2 text-sm hover:bg-slate-50 text-red-600">
                                    Logg ut
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </header>
            {
                showBroadcastModal && (
                    <BroadcastModal
                        show={showBroadcastModal}
                        onClose={() => setShowBroadcastModal(false)}
                        baseUrl={baseUrl}
                        currentUser={currentUser}
                    />
                )
            }
        </>
    )
}